// Petit bouton réglages (coin haut-droit) des pages publiques créateur.
// Ouvre un mini-menu : déconnexion TikTok. (Le switch de langue passe par le
// LanguageSelector global sur le public-dashboard.)
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { I } from './primitives';

export function PublicSettingsButton() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const logout = async () => {
    try { await supabase.auth.signOut(); } catch { /* ignore */ }
    try {
      localStorage.removeItem('creator_profile');
      localStorage.removeItem('creator_tiktok');
      localStorage.removeItem('public_profile');
    } catch { /* ignore */ }
    navigate('/my/login', { replace: true });
  };

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Settings"
        style={{
          width: 36, height: 36, borderRadius: 10,
          background: 'var(--bg-3)', border: '1px solid var(--line-1)',
          color: 'var(--fg-2)', display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
      >
        <I.Settings size={18} stroke="currentColor" />
      </button>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 40 }} />
          <div style={{
            position: 'absolute', top: 42, right: 0, zIndex: 41,
            minWidth: 160, background: 'var(--bg-2)', border: '1px solid var(--line-1)',
            borderRadius: 12, padding: 6, boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
          }}>
            <button
              onClick={logout}
              style={{
                width: '100%', display: 'flex', alignItems: 'center', gap: 8,
                padding: '10px 12px', borderRadius: 8, background: 'transparent',
                border: 'none', color: 'var(--fg-1)', fontSize: 13, fontWeight: 600, textAlign: 'left',
              }}
            >
              <I.Logout size={16} stroke="currentColor" />
              Sign out
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default PublicSettingsButton;
